<app-loading class="full-width-height" [type]="'rating'" *ngIf="!showPage"></app-loading>
<ng-container *ngIf="showPage">
    <ion-header>
        <ion-toolbar color="white">
            <ion-buttons slot="start">
                <ion-button (click)="goBack()">
                    <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>
                <app-offline-indicator></app-offline-indicator>
                {{ 'APP_RATING.title' | translate }}
            </ion-title>
        </ion-toolbar>
    </ion-header>
    <ion-content>
        <div class="content-div">
            <ion-card class="box-shadow">
                <div class="ion-text-center ion-margin">
                    <ion-text class="font-20 font-med">{{ 'APP_RATING.intro' | translate }}</ion-text>
                </div>
                <div class="ion-text-center ion-margin">
                    <ion-text class="font-12">{{ 'APP_RATING.serve' | translate }}</ion-text>
                </div>
                <ion-grid class="ion-margin">
                    <ion-row>
                        <ion-col>
                            <ion-card class="logo-card background-transparent ion-no-margin" (click)="openFacebookReview()" button>
                                <ion-img class="store-img center" src="./assets/wedding/img/store/logo/facebook.png"></ion-img>
                            </ion-card>
                        </ion-col>
                        <!-- <ion-col>
                            <ion-card class="logo-card background-transparent ion-no-margin" (click)="openGoogleReview()" button>
                                <ion-img class="store-img center" src="./assets/wedding/img/store/logo/google.png"></ion-img>
                            </ion-card>
                        </ion-col> -->
                        <ion-col>
                            <ion-card class="logo-card background-transparent ion-no-margin" (click)="openAppStoreReview()" button>
                                <ion-img class="store-img center" src="./assets/wedding/img/store/logo/appstore.png"></ion-img>
                            </ion-card>
                        </ion-col>
                        <ion-col *ngIf="!iosApp">
                            <ion-card class="logo-card background-transparent ion-no-margin" (click)="openPlayStoreReview()" button>
                                <ion-img class="store-img center" src="./assets/wedding/img/store/logo/playstore.png"></ion-img>
                            </ion-card>
                        </ion-col>
                        <ion-col *ngIf="!iosApp">
                            <ion-card class="logo-card background-transparent ion-no-margin" (click)="openAppGalleryReview()" button>
                                <ion-img class="store-img center" src="./assets/wedding/img/store/logo/appgallery.svg"></ion-img>
                            </ion-card>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card>
            
            <ion-card class="box-shadow" color="tertiary" (click)="goContactPage()" button >
                <div class="ion-text-center ion-margin">
                    <ion-text class="font-12" [innerHTML]="'APP_RATING.help' | translate"></ion-text>
                </div>
            </ion-card>
            
            <ion-card class="box-shadow">
                <div class="ion-text-center ion-margin">
                    <ion-text class="font-12">{{ 'APP_RATING.feedback' | translate }}</ion-text>
                </div>
                <div class="ion-text-center ion-margin">
                    <ion-button expand="block" (click)="goAppRating()">
                        {{ 'APP_RATING.btn' | translate }}
                    </ion-button>
                </div>
            </ion-card>
        </div>
    </ion-content>
</ng-container>